import { CoreUiException } from "./core-ui-exception";

/**
 * Occurs when there is a validation error
 */
export class ValidationException extends CoreUiException {

    constructor(message: string, originalError?: any) {

        super("ValidationException", message, originalError);

        // Work around for Error Extension
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, ValidationException.prototype);
    }
}
